"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EwelinkCard = EwelinkCard;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ewelink_1 = require("../../../features/apis/ewelink");
var hooks_1 = require("../../../store/hooks");
var api_error_message_1 = require("../../../utils/api-error-message");
var client_scoped_query_1 = require("../../../utils/client-scoped-query");
var use_has_permission_1 = require("../../../utils/use-has-permission");
var button_component_1 = require("../../ui/button-component");
var integration_card_1 = require("../integration-card");
var ewelink_disconnect_modal_1 = require("./ewelink-disconnect-modal");
function EwelinkCard() {
    var _this = this;
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var userId = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a._uid; });
    var canView = (0, use_has_permission_1.useHasPermission)("view_integrations");
    var canUpdate = (0, use_has_permission_1.useHasPermission)("update_integrations");
    var _a = (0, react_1.useState)(false), isDisconnectOpen = _a[0], setIsDisconnectOpen = _a[1];
    var _b = (0, react_1.useState)(""), connectError = _b[0], setConnectError = _b[1];
    var _c = (0, ewelink_1.useGetEwelinkIntegrationQuery)({ clientId: clientId, userId: userId !== null && userId !== void 0 ? userId : "" }, { skip: !userId || !clientId || !canView }), currentData = _c.currentData, isFetching = _c.isFetching, error = _c.error;
    var _d = (0, ewelink_1.useStartEwelinkConnectMutation)(), startEwelinkConnect = _d[0], isStarting = _d[1].isLoading;
    // Blocks a second click before React renders the loading state; the page is about to navigate away anyway.
    var connectInFlightRef = (0, react_1.useRef)(false);
    var integration = currentData === null || currentData === void 0 ? void 0 : currentData.content;
    var isConnected = (integration === null || integration === void 0 ? void 0 : integration.status) === "CONNECTED";
    var needsReconnect = (integration === null || integration === void 0 ? void 0 : integration.status) === "RECONNECT_REQUIRED";
    var facts = (integration === null || integration === void 0 ? void 0 : integration.connectedAt) && isConnected ? [{ label: "Connected", value: new Date(integration.connectedAt).toLocaleString() }] : [];
    var handleConnect = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, startError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (connectInFlightRef.current || isStarting) {
                        return [2 /*return*/];
                    }
                    connectInFlightRef.current = true;
                    setConnectError("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, startEwelinkConnect({ clientId: clientId }).unwrap()];
                case 2:
                    response = _a.sent();
                    window.location.assign(response.content.url);
                    return [3 /*break*/, 4];
                case 3:
                    startError_1 = _a.sent();
                    setConnectError((0, api_error_message_1.getApiErrorMessage)(startError_1, "Unable to start the eWeLink sign-in. Please try again."));
                    connectInFlightRef.current = false;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var problem = connectError || (error ? (0, api_error_message_1.getApiErrorMessage)(error, "Unable to load the eWeLink connection.") : "");
    if (!canView) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(integration_card_1.IntegrationCard, { title: "Sonoff (eWeLink)", icon: "solar:plug-circle-linear", integration: integration, facts: facts, isLoading: isFetching && !currentData, error: problem, actions: canUpdate && currentData ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isConnected && (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: needsReconnect ? "Reconnect" : "Connect", onPress: handleConnect, isPending: isStarting }), (isConnected || needsReconnect) && ((0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Disconnect", variant: "secondary", onPress: function () { return setIsDisconnectOpen(true); }, isDisabled: isStarting }))] })) : undefined }), (0, jsx_runtime_1.jsx)(ewelink_disconnect_modal_1.EwelinkDisconnectModal, { isOpen: isDisconnectOpen, clientId: clientId, onClose: function () { return setIsDisconnectOpen(false); } })] }));
}
